module.exports = __webpack_public_path__ + "static/media/thumb_DXHI4388_1024a.6c24d289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/thumb_DXHI4388_1024a.jpg
// module id = 146
// module chunks = 0